import { Link } from '@amzn/meridian';
import type { FC } from 'react';
import { sizes } from '../../resources/tokens';
import type { ProcessedError } from './ErrorAlert.types';

type MultipleErrorDisplayProps = {
  processedErrors: ProcessedError[];
  hasAnyAdditionalLines: boolean;
  isExpanded: boolean;
  onToggleExpanded: () => void;
};

/**
 * Displays multiple error messages with optional expandable additional details.
 * Shows the first line of each error, with expandable view for all additional lines.
 */
export const MultipleErrorDisplay: FC<MultipleErrorDisplayProps> = ({
  processedErrors,
  hasAnyAdditionalLines,
  isExpanded,
  onToggleExpanded,
}) => (
  <>
    <ul>
      {processedErrors.map((processedError, errorIndex) => (
        <li key={`error-${errorIndex}-${processedError.firstLine.substring(0, 20)}`}>{processedError.firstLine}</li>
      ))}
    </ul>
    {hasAnyAdditionalLines && !isExpanded && <Link onClick={onToggleExpanded}>See more...</Link>}
    {isExpanded && (
      <>
        <div
          style={{
            marginTop: sizes.smallPx,
          }}
        >
          <ul>
            {processedErrors.map((processedError, errorIndex) =>
              processedError.additionalLines.map((line, lineIndex) => (
                <li key={`error-${errorIndex}-line-${lineIndex}-${line.substring(0, 20)}`}>{line}</li>
              )),
            )}
          </ul>
        </div>
        <Link onClick={onToggleExpanded}>Show less</Link>
      </>
    )}
  </>
);
